"use client";
import React, { FC, useState } from "react";
import OnlinePayment from "./OnlinePayment";
import UseCode from "./UseCode";
import WalletPayment from "./WalletPayment";
import { DialogClose } from "@/components/ui/dialog";
import ProgressBar from "../ProgressBar/ProgressBar";

type Props = {
  walletCharge?: boolean;
  codeMethod?: boolean;
  tabIndex: number;
  setTabIndex: (tab: number) => void;
  send: boolean;
  error?: string | null;
  item: any;
  handleSubmit: (id: number, type: number, code?: string) => void;
  onlineField?: any;
};

const index: FC<Props> = ({
  walletCharge = false,
  codeMethod = false,
  tabIndex,
  setTabIndex,
  send,
  error,
  item,
  handleSubmit,
  onlineField,
}) => {
  const [code, setCode] = useState("");
  const [startProgress, setStartProgress] = useState<boolean>(false);
  console.log(item, "item");

  return (
    <div className="flex flex-col gap-5 md:gap-5 mb-5">
      {!item.free && (
        <>
          <div className="bg-[#323538] p-2 md:py-5 md:px-2 rounded-[10px]">
            {(item.price > 0 || tabIndex === 3 || walletCharge) &&
              !item.free && (
                <div className="flex items-center gap-2 xl:gap-2 bg-[#474A4D] p-4 rounded-[10px]">
                  {!walletCharge && (
                    <p
                      className={`grow text-16 font-[500] text-center py-3 px-3 text-nowrap rounded-[10px] cursor-pointer ${
                        tabIndex === 1
                          ? "bg-primaryColor text-[#202225]"
                          : "text-white bg-[#5B5E61]"
                      }`}
                      onClick={() => setTabIndex(1)}
                    >
                      دفع اونلاين
                    </p>
                  )}
                  {!walletCharge && (
                    <p
                      className={`grow text-16 font-[500] text-center py-3 px-3 text-nowrap rounded-[10px] cursor-pointer ${
                        tabIndex === 2
                          ? "bg-primaryColor text-[#202225]"
                          : "text-white bg-[#5B5E61]"
                      }`}
                      onClick={() => setTabIndex(2)}
                    >
                      دفع من المحفظة
                    </p>
                  )}
                  {codeMethod && (
                    <p
                      className={`grow text-16 font-[500] text-center py-3 px-3 md:px-3 text-nowrap rounded-[10px] cursor-pointer ${
                        tabIndex === 3
                          ? "bg-primaryColor text-[#202225]"
                          : "text-white bg-[#5B5E61]"
                      }`}
                      onClick={() => setTabIndex(3)}
                    >
                      استخدام كود
                    </p>
                  )}
                </div>
              )}
          </div>
          {tabIndex !== 3 && onlineField}
          {tabIndex === 1 ? (
            <OnlinePayment price={item.price} free={item.free} />
          ) : tabIndex === 2 ? (
            <WalletPayment price={item.price} />
          ) : (
            <UseCode price={item.price} code={code} setCode={setCode} />
          )}
        </>
      )}

      <div className=" flex gap-3 mt-7 w-full ">
        {/* <DialogTrigger asChild> */}
        <button
          type="submit"
          className=" text-16 text-[#202225] p-2.5 rounded-[8px] bg-primaryColor grow"
          disabled={send}
          onClick={() => {
            if (tabIndex !== 3) {
              handleSubmit(item.id, tabIndex - 1);
            } else {
              handleSubmit(item.id, tabIndex - 1, code);
            }
            {
              item.subscription_price !== 0 && setStartProgress(true);
            }
          }}
        >
          {send
            ? "جاري الارسال..."
            : (item.price > 0 || tabIndex === 3 || walletCharge) && !item.free
            ? "شراء"
            : (item.price && item.price === 0) ||
              item.free ||
              item.subscription_price === 0
            ? "اشترك مجانا"
            : "اشترك"}
        </button>
        {/* </DialogTrigger> */}
        <DialogClose className=" text-16 text-white p-2.5 rounded-[8px] bg-[#474A4D] grow">
          الغاء
        </DialogClose>
      </div>
      {/* {startProgress && !error && <ProgressBar startProgress={startProgress} />} */}
    </div>
  );
};

export default index;
